var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "PIPELINE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #PIPELINE .cls-2 {\n        fill: #fff;\n      }\n\n      #PIPELINE .cls-1 {\n        fill: #3e4346;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_PIPELINE",
    transform: "translate(-641 -63)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    className: "cls-2",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(641 63)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_77",
    "data-name": "Gruppe 77",
    transform: "translate(641 63)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_162",
    "data-name": "Pfad 162",
    className: "cls-1",
    d: "M18,0a12.75,12.75,0,0,0-2,.1A18.65,18.65,0,0,0,9,2.4,18.005,18.005,0,1,0,33.1,27.8a19.259,19.259,0,0,0,2.7-7A24.583,24.583,0,0,0,36,18,18.053,18.053,0,0,0,18,0ZM30.7,27.8A16.035,16.035,0,0,1,2,18,16.019,16.019,0,0,1,9,4.8a16.54,16.54,0,0,1,7-2.7A12.75,12.75,0,0,1,18,2,16.047,16.047,0,0,1,34,18a26.352,26.352,0,0,1-.2,2.8A18.353,18.353,0,0,1,30.7,27.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_163",
    "data-name": "Pfad 163",
    className: "cls-1",
    d: "M34.6,21.8a18.052,18.052,0,0,1-2,5H26.3v-5h8.3m1.2-1H25.3v7h7.9a19.092,19.092,0,0,0,2.6-7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_38",
    "data-name": "Rechteck 38",
    className: "cls-1",
    width: 2,
    height: 9,
    transform: "translate(22.4 19.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_164",
    "data-name": "Pfad 164",
    className: "cls-1",
    d: "M21.4,28.2H19A10.67,10.67,0,0,1,8.4,17.6V15.3h8v2.3A2.647,2.647,0,0,0,19,20.2h2.3v8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_39",
    "data-name": "Rechteck 39",
    className: "cls-1",
    width: 9,
    height: 2,
    transform: "translate(8 12.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_165",
    "data-name": "Pfad 165",
    className: "cls-1",
    d: "M15,1.3v9H10V3a16.413,16.413,0,0,1,5-1.7M16,.1A18.65,18.65,0,0,0,9,2.4v8.8h7V.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.9a1ea1c87b71325a698f9d2d6002cdfc.svg";
export { ForwardRef as ReactComponent };